"use client";
import { FC, useCallback, useReducer } from "react";
import { layoutContext, DrawerOptions } from "./layoutContext";
import { layoutReducer } from "./layoutReducer";

export type LayoutState = {
  leftDrawer: DrawerOptions;
};

const LAYOUT_INITIAL_STATE: LayoutState = {
  leftDrawer: {
    isOpen: false,
  },
};

type ContentProps = {
  children: React.ReactNode;
};

export const LayoutProvider: FC<ContentProps> = ({
  children,
}: ContentProps) => {
  const [state, dispatch] = useReducer(layoutReducer, LAYOUT_INITIAL_STATE);

  const openCloseLeftDrawer = useCallback(() => {
    dispatch({ type: "UI - OpenClose Left Drawer" });
  }, []);

  return (
    <layoutContext.Provider
      value={{
        ...state,
        openCloseLeftDrawer,
      }}
    >
      {children}
    </layoutContext.Provider>
  );
};
